import './Orders.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { ROUTE_ORDERS } from '@/common/constants';
import { useAuth } from '@/common/contexts/AuthContext';
import { useOrdersContext } from '@/common/contexts/OrdersContext/OrdersContext';
import OrdersList from '@/ebat/components/blocks/Orders/OrdersList/OrdersList';

import { OrdersDefaultProps, OrdersPropTypes } from './Orders.proptypes';

const Orders = ({ className }) => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const { data, isDisabled } = useOrdersContext();

  if (user?.functionality_accesses?.orders && data?.data?.length > 0) {
    return (
      <div className={cn('home-orders', className)}>
        <div className="wrapper">
          <div className="title">
            <h2 className="h2">{t('ebat:entities:home.orders.title')}</h2>
            <NavLink className="more" to={ROUTE_ORDERS}>
              {t('common:messages:actions.see_all')}
            </NavLink>
          </div>
          <OrdersList isDisabled={isDisabled} orders={data.data} />
        </div>
      </div>
    );
  }

  return null;
};

Orders.defaultProps = {
  ...OrdersDefaultProps,
};

Orders.propTypes = {
  ...OrdersPropTypes,
};

export default Orders;
